import clsx from 'clsx';
import { LabelHTMLAttributes, ReactNode } from 'react';

type LabelSize = 'large' | 'medium' | 'small';

type Props = {
  size?: LabelSize;
  children: ReactNode;
} & LabelHTMLAttributes<HTMLLabelElement>;

const sizeStyles: Record<LabelSize, string> = {
  large: 'text-base',
  medium: 'text-sm',
  small: 'text-xs',
};

export const Label = ({ size = 'medium', children, ...props }: Props) => {
  const { className } = props;

  return (
    <label
      {...props}
      className={clsx(sizeStyles[size], 'font-medium text-gray-900', className)}
    >
      {children}
    </label>
  );
};
